<script>
  import { onDestroy } from "svelte";
  import { lang } from "../lib/stores";
  let selectedLang;
  const unsubscribe = lang.subscribe((value) => selectedLang = value);
  onDestroy(unsubscribe);
</script>

<section class="mapBaggio">
  <div class="mapBaggio-details">
    <blockquote>
      <p>
        Io sono un negro, terrorista, culo bianco, ladro, bangla, muso giallo<br
        />
        <em>Trasformo Baggio in un posto più bello</em>, questa pioggia è uno
        sballo<br />
        Spero solo, fra', quest'oscurità sia solo un abbaglio<br />
        Ti prego, dimmi chi ci difende da chi dovrebbe farlo
      </p>
      <p><small>Wily Wily, Lunga Vita a Sto, 2017</small></p>
    </blockquote>
    <div class="p">
      <p>
        <img
          src="/assets/img/baggio.webp"
          loading="lazy"
          alt="Mappa di Baggio"
          class="map"
        />
        {#if selectedLang === 'it'}
          <a href="https://it.wikipedia.org/wiki/Baggio_(Milano)" target="_blank"
            >Baggio</a
          >
          è un quartiere nella periferia ovest di Milano. È sempre rimasto abbastanza
          isolato dal resto della città perché delimitato a est dal grande
          <a href="https://it.wikipedia.org/wiki/Parco_delle_Cave" target="_blank"
            >Parco delle Cave</a
          >
          che lo separa dai quartieri più centrali. Antico comune agricolo, annesso
          a Milano durante il fascismo, ha vissuto ben pochi avvenimenti di rilievo
          nella sua storia: la partenza (nel 1928) del
          <a
            href="https://it.wikipedia.org/wiki/Italia_(dirigibile)"
            target="_blank">Dirigibile Italia</a
          >
          alla volta del Polo Nord, nella disastrosa spedizione guidata da
          <a href="https://it.wikipedia.org/wiki/Umberto_Nobile" target="_blank"
            >Umberto Nobile</a
          >
          e, nel 1975, la tristissima vicenda di cronaca che ha visto come vittima
          <a href="https://www.wikimafia.it/wiki/Luisa_Fantasia" target="_blank"
            >Luisa Fantasia</a
          >. Per intenderci: prima di Ghali la personalità più conosciuta di
          Baggio era
          <a href="https://it.wikipedia.org/wiki/Giacomo_Tazzini" target="_blank"
            >Giacomo Tazzini</a
          >, architetto reale (benché, c'è da dire,
          <a href="https://www.youtube.com/watch?v=mq7xG5bxP48" target="_blank"
            >Davide Calgaro</a
          > si sta facendo strada nella stand-up comedy). A partire dagli anni Cinquanta
          del Novecento Baggio è stato protagonista di un boom edilizio popolare che
          ha dato al quartiere la forma che ha ora, ma proprio il relativo isolamento
          dal resto della città ha fatto sì che si sviluppasse nei suoi abitanti un
          grande attaccamento al quartiere.
        {:else}
          <a href="https://it.wikipedia.org/wiki/Baggio_(Milano)" target="_blank">Baggio</a> 
          is a neighborhood in the western outskirts of Milan. It has always remained quite isolated from
          the rest of the city because it is bordered to the east by the large
           <a href="https://it.wikipedia.org/wiki/Parco_delle_Cave" target="_blank">Parco delle Cave</a> 
          that separates it from the more central neighborhoods. An ancient agricultural municipality,
          annexed to Milan during fascism, it has experienced very few significant events in its history:
          the departure (in 1928) of the <a href="https://it.wikipedia.org/wiki/Italia_(dirigibile)" target="_blank">Dirigibile
          Italia</a> towards the North Pole, in the disastrous expedition led by
           <a href="https://it.wikipedia.org/wiki/Umberto_Nobile" target="_blank">Umberto Nobile</a> 
          and, in 1975, the very sad news story that saw
           <a href="https://www.wikimafia.it/wiki/Luisa_Fantasia" target="_blank">Luisa Fantasia</a> as its victim.
           To be clear: before Ghali, the best-known personality in Baggio was
           <a href="https://it.wikipedia.org/wiki/Giacomo_Tazzini" target="_blank">Giacomo Tazzini</a>, royal architect
           (although, it must be said, <a href="https://www.youtube.com/watch?v=mq7xG5bxP48" target="_blank">Davide Calgaro</a>
           is making his way in stand-up comedy). Starting from the 1950s, Baggio experienced a boom in public housing that gave
           the neighborhood its current shape. However, it was precisely the relative isolation from the rest of the city that
           fostered a strong attachment to the neighborhood among its inhabitants.
        {/if}
      </p>
    </div>
    <blockquote>
      <p>
        L'industria è un tritacarne, io sono halal<br />
        Il flow è turbofuoco, scelgo Charliezard<br />
        <em>Mi chiedi da dove vengo? Baggio boulevard</em><br />
        Karma è l'unica tipa che torna come un boomerang
      </p>
      <p><small>Dende, Lunga Vita a Sto, 2017</small></p>
    </blockquote>
    <div class="p">
      <p>
        {#if selectedLang === 'it'}
          Ghali cita <em>Baggio</em>{" "}<em class="data">3</em> volte, nei brani
          <em>Dende</em>, <em>Wily Wily</em> (entrambi in Lunga Vita a Sto, 2017)
          e <em>Boogieman</em> (DNA, 2020). Sembra poco, ma non lo è: prima di lui
          solo tre artisti, non di Baggio, avevano menzionato il quartiere in un
          loro pezzo: i grandi
          <a href="https://it.wikipedia.org/wiki/Enzo_Jannacci" target="_blank"
            >Enzo Jannacci</a
          >
          e
          <a href="https://it.wikipedia.org/wiki/Giorgio_Gaber" target="_blank"
            >Giorgio Gaber</a
          >
          (<a href="https://www.youtube.com/watch?v=3rT_zpueZ9k" target="_blank"
            >Prendeva il treno</a
          >, 1964 e
          <a href="https://www.youtube.com/watch?v=xfhwE0Wa6mU" target="_blank"
            >Il tic</a
          >, 1972) e
          <a href="https://it.wikipedia.org/wiki/Leone_Di_Lernia" target="_blank"
            >Leone di Lernia</a
          >
          (<a href="https://www.youtube.com/watch?v=PipvISEcfu4" target="_blank"
            >Sei di Baggio</a
          >, 1995). L'amore di Ghali per il suo quartiere è anche dimostrato dal
          fatto che, in occasione del suo album <em>DNA</em>, nel 2020,
          <em>ha fatto realizzare delle affissioni apposite</em> (nella foto di pessima
          qualità qua sotto quella in via delle Forze Armate).
        {:else}
          Ghali mentions <em>Baggio</em> <em class="data">3</em> times, in the tracks
          <em>Dende</em> , <em>Wily Wily</em> (both in Lunga Vita a Sto, 2017) and <em>Boogieman</em> (DNA, 2020).
          It may seem like a small number, but it’s not: before him, only three artists—not from Baggio—had mentioned the
          neighborhood in their songs: the great
          <a href="https://it.wikipedia.org/wiki/Enzo_Jannacci" target="_blank">Enzo Jannacci</a> 
          and
            <a href="https://it.wikipedia.org/wiki/Giorgio_Gaber" target="_blank">Giorgio Gaber</a> 
          (<a href="https://www.youtube.com/watch?v=3rT_zpueZ9k" target="_blank">Prendeva il treno</a> , 1964 and
            <a href="https://www.youtube.com/watch?v=xfhwE0Wa6mU" target="_blank">Il tic</a> , 1972) and
            <a href="https://it.wikipedia.org/wiki/Leone_Di_Lernia" target="_blank">Leone di Lernia</a> 
          (<a href="https://www.youtube.com/watch?v=PipvISEcfu4" target="_blank">Sei di Baggio</a> , 1995). Ghali’s
          love for his neighborhood is also demonstrated by the fact that, for the release of his album <em>DNA</em> in
          2020, <em>he had special posters made</em> (in the low-quality photo below, one of them is on Via delle Forze Armate).
        {/if}
      </p>
      <p>
        <img
          src="/assets/img/ghali-billboard.webp"
          loading="lazy"
          alt="Baggio Sempre nel mio DNA"
        />
      </p>
    </div>

    <blockquote>
      <p>
        <em>A Baggio, quando piove, piove un botto</em><br />
        Esco con lei, metto il pigiama sotto<br />
        Ma non perché ci devo andare a letto<br />
        È che quando sto giù un botto non basta il giubbotto
      </p>
      <p><smal>Boogieman, DNA, 2020</smal></p>
    </blockquote>
    <div class="p">
      <p>
        {#if selectedLang === 'it'}
          Questa inaspettata popolarità ha fatto bene al quartiere? Chi lo sa. Di
          sicuro ha fatto bene ad <em>Aziz</em>, il suo barbiere, e a
          <em>Panzerotto Mio</em>, la pizzeria che ha in menu il
          <em>panzerotto Gangster by Ghali</em>, con gli ingredienti selezionati
          personalmente dal nostro (zucchine, melanzane, funghi, peperoni). Di
          contro,
          <a
            href="https://www.fanpage.it/milano/ghali-sanremo-2024-festival-fa-una-dedica-alla-sua-baggio-la-periferia-milanese-e-la-nuova-italia/"
            target="_blank">la dedica fatta a Sanremo al quartiere</a
          >
          ha anche spinto diversi giornalisti ad
          <em
            >uscire per la prima volta nella loro vita fuori dalla cerchia dei
            Navigli</em
          >, cosa che ha prodotto reportage tra il
          <a
            href="https://www.magzine.it/casa-mia-una-giornata-nella-baggio-di-ghali/"
            target="_blank">ridicolo</a
          >
          e l'<a
            href="https://www.vanityfair.it/article/baggio-milano-come-cosa-vedere-indirizzi"
            target="_blank">offensivo</a
          >.
        {:else}
          Has this unexpected popularity been good for the neighborhood? Who knows. It has certainly benefited <em>Aziz</em>,
          his barber, and to <em>Panzerotto Mio</em>, the pizzeria that offers the <em>Panzerotto Gangster by Ghali</em>,
          with ingredients personally selected by him (zucchini, eggplant, mushrooms, peppers). On the other hand, <a
          href="https://www.fanpage.it/milano/ghali-sanremo-2024-festival-fa-una-dedica-alla-sua-baggio-la-periferia-milanese-e-la-nuova-italia/"
          target="_blank">the tribute to the neighborhood at Sanremo</a> also prompted several journalists to venture out for the first time
          in their lives beyond the Navigli area, which led to reports that were at times <a
          href="https://www.magzine.it/casa-mia-una-giornata-nella-baggio-di-ghali/"
          target="_blank">ridiculous</a> and <a
          href="https://www.vanityfair.it/article/baggio-milano-come-cosa-vedere-indirizzi"
          target="_blank">offensive</a>.
        {/if}
      </p>
    </div>
    <blockquote>
      <p>
        Li metto in ginocchio come un tossico che basa<br />
        <em>Nessuno ti rasa come Aziz from Casa</em><br />
        C'è chi fa i pezzi per il naso e chi per la NASA
      </p>
      <p><small>Optional, Llunga Vita a Sto, 2017</small></p>
    </blockquote>
  </div>
</section>

<style>
  .mapBaggio img {
    display: block;
    height: auto;
    width: 100%;
  }

  .mapBaggio img.map {
    aspect-ratio: 1 / 1;
    display: block;
    height: auto;
    margin-bottom: 2rem;
    width: 100%;
  }

  @media screen and (min-width: 768px) {
    .mapBaggio img.map {
      float: left;
      margin: 0 1rem 1rem 0;
      width: 200px;
    }
  }

  @media screen and (min-width: 1024px) {
    .mapBaggio img.map {
      margin: 0 2rem 2rem 0;
      width: 300px;
    }
  }
</style>
